export default __webpack_public_path__ + "assets/images/727bc617e4713ed5b11f8ff5ae03a40a.png";